import React, { useContext } from 'react';
import { Link } from '@tanstack/react-router';
import { DestinationContext } from '../../../contexts/DestinationContext';
import styles from './SplitCards.module.scss';

const SplitCards = () => {
  const destination = useContext(DestinationContext);
  const accommodationImage = destination?.images?.accommodation?.[0]?.url || destination?.images?.home?.[0]?.url;
  const safariImage = destination?.images?.safari?.[0]?.url || destination?.images?.home?.[0]?.url;

  return (
    <section className={styles.split}>
      <Link to="/accommodation" className={styles.card}>
        {accommodationImage && (
          <img
            src={accommodationImage}
            alt="Accommodation in destination"
            className={styles.bg}
            loading="lazy"
            decoding="async"
          />
        )}
        <div className={styles.inner}>
          <div className={styles.kick}>Accommodation</div>
          <h2>View All Places to Stay</h2>
          <p>
            From ultra-luxury tented camps to intimate conservancy lodges — browse every
            verified property in the {destination?.name} ecosystem.
          </p>
          <span className={styles.btn}>Browse Camps &amp; Lodges →</span>
        </div>
      </Link>
      <Link to="/safaris" className={`${styles.card} ${styles.balloonCard}`}>
        {safariImage && (
          <img
            src={safariImage}
            alt="Safaris in destination"
            className={`${styles.bg} ${styles.balloonBg}`}
            loading="lazy"
            decoding="async"
          />
        )}
        <div className={styles.inner}>
          <div className={styles.kick}>Safari Experiences</div>
          <h2>Safaris That Include {destination?.name}</h2>
          <p>
            Discover multi-destination safari itineraries that weave {destination?.name} into
            a wider East African adventure.
          </p>
          <span className={styles.btn}>Find Out More →</span>
        </div>
      </Link>
    </section>
  );
};

export default SplitCards;
